// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7ZVsN","sectionPrimary":"Footer_sectionPrimary__6nfYa","sectionSecondary":"Footer_sectionSecondary__e8pQF","social":"Footer_social__fgBIS"};